import * as React from "react";
import { AlertColor, Box } from "@mui/material";
import WorkEntryDataGrid from "../../sessions/sessionDetail/payroll/workEntryDataGrid";
import CclAlertSnackbar from "../../../components/common/cclAlertSnackbar";

export type PayrollProjectWorkDetailsProps = {
    projectId: string;
    projectName: string;
    projectCode: string;
    sessionId: string;
    revRecDate?: string | Date | null;
    onViewFacultyDetails: (workEntryId: number) => void;
    loadingFacultyDetails: boolean;
};

const PayrollProjectWorkDetails: React.FC<PayrollProjectWorkDetailsProps> = (props) => {
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState("");
    const [snackbarSeverity, setSnackbarSeverity] = React.useState<AlertColor>("info");

    const showSnackbarMessage = (message: string, severity: AlertColor) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setShowSnackbar(true);
    };

    return (
        <Box sx={{ width: 1, height: 1, p: 1 }}>
            <WorkEntryDataGrid
                projectId={props.projectId}
                projectName={props.projectName}
                projectCode={props.projectCode}
                sessionId={props.sessionId}
                revRecDate={props.revRecDate}
                displayWorkEntryDetails={props.onViewFacultyDetails}
                loading={props.loadingFacultyDetails}
                onShowSnackbar={showSnackbarMessage}
            />
            <CclAlertSnackbar
                open={showSnackbar}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={() => setShowSnackbar(false)}
            />
        </Box>
    );
};

export default PayrollProjectWorkDetails;
